/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_AriaInputs */



/**
* | output |
* | --- |
* | "Edit record description" |
*
* @param {Explorer_Info_Description_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_aria = /** @type {((inputs?: Explorer_Info_Description_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "it") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Edit record description")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Edit record description")
	return /** @type {LocalizedString} */ ("Edit record description")
});